module.exports = "https://trybtryb-legacy.web.app/img/crown-icon.a49039af.png";